import React from 'react';

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-600 to-burgundy-700 flex items-center justify-center p-4">
      {children}
    </div>
  );
};

export default AuthLayout;
